export default "__VITE_ASSET__Ce3ccd$4__"